import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeATCCodeList } from "../../../Art57Node/ListEntity/TreeNodeATCCodeList";

export class ATCCodeQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).atcCodeFields;
    const createChidTemplateParams = {nodeType: 2};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).atcCodeConditions;
       super(injector, [], 'ATC Codes', EntityEnum.atccode,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.atccodeTreeNode, TreeNodeATCCodeList, AutoUploadEntityEnum.atccode, createChidTemplateParams);    
    }
}